export const HowItWorksSection = () => {
  const steps = [
    {
      number: '01',
      icon: 'ri-file-text-line',
      title: 'إرسال الطلب',
      description: 'املأ نموذج طلب الاستشارة بمعلوماتك الصحية والشخصية',
    },
    {
      number: '02',
      icon: 'ri-stethoscope-line',
      title: 'مراجعة الطبيب',
      description: 'يراجع الطبيب المختص حالتك الصحية ويضع خطة علاجية مناسبة',
    },
    {
      number: '03',
      icon: 'ri-calendar-check-line',
      title: 'تحديد الموعد',
      description: 'اختر الموعد المناسب لك من التقويم المتاح',
    },
    {
      number: '04',
      icon: 'ri-chat-3-line',
      title: 'التواصل عبر الشات',
      description: 'تحدث مع الطبيب مباشرة عبر المحادثة الآمنة',
    },
    {
      number: '05',
      icon: 'ri-heart-pulse-line',
      title: 'تلقي العلاج والمتابعة',
      description: 'ابدأ رحلة الإقلاع بثقة مع متابعة دورية ومستمرة',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h3 className="text-4xl md:text-5xl font-bold text-primary mb-4">كيف نعمل؟</h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            <strong>خمس خطوات بسيطة</strong> تفصلك عن بداية رحلة الإقلاع الناجحة
          </p>
          <div className="w-24 h-1 bg-accent mx-auto mt-4"></div>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Timeline Line */}
            <div className="hidden lg:block absolute right-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-primary via-secondary to-accent transform translate-x-1/2"></div>

            {/* Steps */}
            <div className="space-y-12">
              {steps.map((step, index) => (
                <div
                  key={index}
                  className={`flex flex-col lg:flex-row items-center gap-8 animate-slide-up ${
                    index % 2 === 0 ? 'lg:flex-row-reverse' : ''
                  }`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {/* Content */}
                  <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-left' : 'lg:text-right'}`}>
                    <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
                      <div className="flex items-center gap-4 mb-4">
                        <div className={`w-12 h-12 bg-gradient-to-br ${
                          index % 3 === 0 ? 'from-primary to-primary-600' :
                          index % 3 === 1 ? 'from-secondary to-secondary-600' :
                          'from-accent to-accent-600'
                        } rounded-lg flex items-center justify-center`}>
                          <i className={`${step.icon} text-white text-2xl`}></i>
                        </div>
                        <span className="text-5xl font-bold text-gray-200">{step.number}</span>
                      </div>
                      <h4 className="text-2xl font-bold text-gray-800 mb-3">{step.title}</h4>
                      <p className="text-gray-600 leading-relaxed">{step.description}</p>
                    </div>
                  </div>

                  {/* Center Circle */}
                  <div className="relative z-10 flex-shrink-0">
                    <div className={`w-16 h-16 bg-gradient-to-br ${
                      index % 3 === 0 ? 'from-primary to-primary-600' :
                      index % 3 === 1 ? 'from-secondary to-secondary-600' :
                      'from-accent to-accent-600'
                    } rounded-full flex items-center justify-center shadow-xl`}>
                      <span className="text-white text-2xl font-bold">{index + 1}</span>
                    </div>
                  </div>

                  {/* Spacer */}
                  <div className="flex-1 hidden lg:block"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};